import React, { useState, useEffect, useRef, useContext } from 'react';
import { useReactToPrint } from 'react-to-print';
import { eliminarTodasLasExtensiones, formatState, primeraLetraMayuscula, soloCelular } from '../../../utils/utils';
import { ContenedorParametros } from '../../components/utils/ContenedorParametros';
import { BotonProcesar } from '../../components/buttons/BotonProcesar';
import { Modal } from '../../components/modal/Modal';
import { useModal } from '../../../hooks/useModal';
import { useSpinner } from '../../../hooks/useSpinner';
import { useEmpresas } from '../../../hooks/useEmpresas';
import { Tooltip } from '../../components/utils/Tooltip';
import { notify } from '../../../utils/utils';
import { UserContext } from '../../../context/provider/UserProvider';
import { SearchTable } from '../../components/utils/SearchTable';
import { useEnlaceQr } from '../../../hooks/useEnlaceQr';
import { Loading } from '../../components/Loading';
import icon_beexqr  from '../../../assets/images/icon_beexqr.fw.png'
import icon_atuqr from '../../../assets/images/icon_atuqr.fw.png'
import { NuevoSelectAutocomplete } from '../../components/forms/NuevoSelectAutocomplete';
import sinImagen from '../../../assets/images/sinImagen.PNG'


// const urlBase = process.env.REACT_APP_BEEDRONE_WEB_API;

const classNameInput = "text-white h-[30px] rounded px-4 caret-white bg-zinc-900 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:opacity-70 disabled:cursor-not-allowed"

export const EnlaceUnidades =()=>{
    const { stateUser, signOut } = useContext(UserContext)
    const [ empresaSeleccionada, setEmpresaSeleccionada ] = useState(0)
    const [ rutaSeleccionada, setRutaSeleccionada ] = useState(0)
    const [ esSubirQrYape, setEsSubirQrYape ] = useState(true);
    const [ isOpenModalYape, openModalYape, closeModalYape ] = useModal(null);
    const [ imagenQrYape, setImagenQrYape ] = useState(null)
    const [ srcYape, setSrcYape ] = useState(sinImagen);
    const imagenYapeRef = useRef(null);
    

    const {
        empresas,
        rutas,
        listarEmpresas,
        listarRutas
    } = useEmpresas()


    const empresasConvertidas = empresas.map(option => ({
        value: option.codEmpresa,
        label: primeraLetraMayuscula(option.nomEmpresa)
    }));

    const recibirValor = (valor) => {
        setEmpresaSeleccionada(valor)
    };

    const {
        unidadQr,
        unidadesQr,
        qrUrl,
        loading,
        isOpenModalUnidadQr,
        closeModalUnidadQr,
        generarQr,
        activarInactivarQr,
        listarUnidadesQr,
        obtenerUnidadQr,
        listarDetalleQrYape,
        detalleYape,
        editarValorDetalleYape,
        guardarQrYape
    } = useEnlaceQr()

    const printRef = useRef(null);
    const reactToPrintRef = useRef(null);
    const reactToPrintYapeRef = useRef(null)
    const [ isOpenModalConfirmacion, openModalConfirmacion, closeModalConfirmacion ] = useModal(false)
    const [ unidadQrSeleccionada, setUnidadQrSeleccionada ] = useState()
    const [ spinner, mostrarSpinner,ocultarSpinner ] = useSpinner()

    useEffect(()=>{
        listarUnidadesQr(empresaSeleccionada, rutaSeleccionada)
    },[loading])


    useEffect(()=>{
        listarRutas(empresaSeleccionada)
    },[empresaSeleccionada])



    const idTablaUnidades = "tablaUnidades"

    const printDiv = () => {
        const printWindow = window.open('', '_blank', 'width=1000,height=1000');
        if (!printWindow || !printRef.current) return;
        const content = printRef.current.innerHTML;

        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
                <head>
                <title>Imprimir QR</title>
                <style>
                    * { margin: 0; padding: 0; box-sizing: border-box; }
                    body {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        min-height: 100vh;
                        background: #f0f0f0;
                        padding: 20px;
                    }
                    .print-container {
                        background: white;
                        width: 350px;
                        height: 350px;
                        border: 2px solid black;
                        position: relative;
                        box-shadow: 0 0 10px rgba(0,0,0,0.1);
                    }
                    .print-container img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        display: block;
                    }
                    .label {
                        left: 0;
                        width: 100%;
                        text-align: center;
                        color: gray;
                        font-family: Arial, sans-serif;
                        font-size: 15px;
                        pointer-events: none;
                    }
                    @media print {
                        body { background: white; padding: 0; }
                        @page { margin: 0.5cm; }
                    }
                </style>
                </head>
                <Modal 
                    isOpen={isOpenModalUnidadQr} 
                    closeModal={closeModalUnidadQr} 
                    title= {unidadQrSeleccionada?.qrTipo == 1? 'Detalles de Qr Biix' : 'Detalles de Qr ATU'}
                    validButton = {{confirm: true, denied: true}}
                    textButtons = {{confirm: 'Imprimir', denied: 'Cerrar'}}
                    action={() => (reactToPrintRef.current ? reactToPrintRef.current.handlePrint() : printDiv())}

                    // action()=>openModalImpresion()

                >
        `);

        printWindow.document.close();
    }

    const subirImagenAMinio = async() => {
        const formData = new FormData();
        const blob = imagenQrYape.slice(0, imagenQrYape.size , 'aplication/json');
        const nuevoArchivo = new File([blob], imagenQrYape.name,{ type: 'aplication/json' });
        formData.append('archivo',nuevoArchivo);
        const queryParameters = {
            NombreCarpeta: 'photos-qr-yape',
            nombreArchivo: eliminarTodasLasExtensiones(imagenQrYape.name)
        }
        const urlEnvioMinio = `https://miniowebapi.abexacloud.com/api/Archivo/subirArchivo?${new URLSearchParams(queryParameters)}`;
        const urlVerImagen = `https://miniowebapi.abexacloud.com/api/Archivo/verImagen?NombreCarpeta=photos-qr-yape&NombreImagen=${eliminarTodasLasExtensiones(imagenQrYape.name)}`;

        const response = await fetch(urlEnvioMinio,{
            method:'POST',
            body: formData
        })
        .then(res => res.json())
        .then(response => {
            !response.isValid && notify(response.content , 'error');
            if(response.isValid){
                return urlVerImagen
            }
        })
        .catch(e => () => {
            notify(`Ocurrió un error: ${e}` ,'error')
        })
        return response
    }

    const registrarImagen = async () => {
        if(imagenQrYape){
            if(detalleYape.telefono !== ''){
                let urlImagenQr = await subirImagenAMinio();
                let imagen64bit = await convertirABase64(imagenQrYape)
                let isValid = await guardarQrYape(detalleYape.telefono, detalleYape.codUnidad, detalleYape.codEmpresa, urlImagenQr, imagen64bit);
                if(isValid){
                    listarUnidadesQr(empresaSeleccionada, rutaSeleccionada);
                    closeModalYape();
                } 
            }
            else{
                notify('Escriba el número de telefono', 'error');
            }
           return
        }
        notify('No ha seleccionado una imagen', 'error');
    }

    const convertirABase64 = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            const base64String = reader.result.split(",")[1];
            resolve(base64String);
          };
          reader.onerror = (error) => reject(error);
        });
    };

    const imprimirImagenYape = useReactToPrint({
        content: () => reactToPrintYapeRef.current,
        // documentTitle: 'Impresión',
        //@page { size: A5; margin: 15mm; }
        pageStyle: `
            
            @media print {

                .qr-9cm {
                    width: 20.1cm !important;
                    height: 20.1cm !important;
                    min-width: 20.1cm !important;
                    min-height: 20.1cm !important;
                    max-width: 20.1cm !important;
                    max-height: 20.1cm !important;
                    page-break-inside: avoid;
                    float: none !important;
                    position: relative !important;
                }

                .qr-imagen {
                    width: 100% !important;
                }

                .qr-imagen img {
                    max-width: 100% !important;
                    max-height: 100% !important;
                    min-width: 100% !important;
                    min-height: 100% !important;
                    width: 100% !important;
                    height: 100% !important;
                    object-fit: contain;
                    margin: 0px !important;
                    padding: 0px !important
                }

                .qr-texto {
                    text-align: center;
                    font-weight: bold;
                    font-size: 12pt;     /* 12pt ≈ 4.23 mm → cabe perfecto */
                    line-height: 1.1;
                    padding: 4px 2px;
                    color: #333;
                }

                body { 
                    -webkit-print-color-background: print;
                    margin: 0.5cm
                }
            }
        `,
        removeAfterPrint: true,
        onAfterPrint: () => console.log('Fin impresion')
    })
        
    const printDiv2 = useReactToPrint({
        content: () => reactToPrintRef.current,
        // documentTitle: 'Impresión',
        //@page { size: A5; margin: 15mm; }
        pageStyle: `
            
            @media print {
                .qr-9cm {
                    width: 20.1cm !important;
                    height: 20.1cm !important;
                    min-width: 20.1cm !important;
                    min-height: 20.1cm !important;
                    max-width: 20.1cm !important;
                    max-height: 20.1cm !important;

                }

                .qr-imagen {
                    width: 100% !important;
                }

                .qr-imagen img {
                    max-width: 100% !important;
                    max-height: 100% !important;
                    min-width: 100% !important;
                    min-height: 100% !important;
                    width: 100% !important;
                    height: 100% !important;
                    object-fit: contain;
                    margin: 0px !important;
                    padding: 0px !important
                }

                body { 
                    -webkit-print-color-background: print;
                    margin: 20px;
                }
            }
        `,
        removeAfterPrint: true,
        onAfterPrint: () => console.log('Fin impresion')
    })

    const QrImpresion = React.forwardRef((props, ref) => {
        const {
            qrUrl,
            unidadQr={
                abrevEmpresa: 'Prueba',
                nomRuta:'301',
                padronUnidad: '001',
                placaUnidad: '123-abc'
            }
        } = props
        return(
            <div 
                ref={ref}
                style={{
                    width: '100vh',
                    minWidth: '100vh',
                    height: '100vh',
                    minHeight: '100vh',
                    // background: 'blue',
                    padding: '1mm'
                }}
            >
                <div
                    className='qr-9cm'
                    style={{ 
                        border: '2px solid black',
                        display: 'flex',
                        flexDirection: 'column',
                        padding:0,
                        margin: 0,
                        justifyContent: 'space-between',
                        overflow: 'hidden',
                        boxSizing: 'border-box',
                        position: 'absolute'
                    }}
                >                        
                    {/* QR: tamaño fijo */}
                    {/* // style={{ width: '100%', height: '8.35cm', padding: 0, margin: 0 }} */}
                    <div
                        className='qr-imagen'
                        style={{
                            // reservar el alto para la imagen dejando espacio para el label inferior
                            // width: '100%',
                            // height: 'calc(100% - 18px)',
                            // display: 'flex',
                            // alignItems: 'center',
                            // justifyContent: 'center',
                            // overflow: 'hidden',
                            boxSizing: 'border-box',
                            padding: 0,
                            margin:0,
                            // background: 'red'
                        }}
                    >
                        <img 
                            src={qrUrl} 
                            style={{ 
                                // objectFit: 'contain',
                                // padding: 0,
                                // margin: 0,
                                // minWidth: '100%',
                                // minHeight: '100%',
                                // maxWidth: '100%',
                                // maxHeight: '100%',
                                // width: '100%',
                                // height: '100%',
                                // display: 'block',
                             }} 
                            alt="QR"
                        />
                    </div>

                    {/* Texto: se ajusta al ancho, rompe líneas */}
                    <div style={{ 
                            width: '100%', 
                            // background: 'pink', 
                            padding: '4px 2px', 
                            position: 'absolute', 
                            top:'18.95cm', 
                            boxSizing: 'border-box'
                        }}
                    >
                        <label style={{ 
                            color: 'gray',
                            fontFamily: 'Arial, sans-serif',
                            fontSize: '17px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            padding: 0,
                            margin: 0,
                            width: '100%',
                            display: 'block',
                            wordWrap: 'break-word',
                            overflowWrap: 'break-word',
                            lineHeight:'0.9em'
                        }}>
                            {unidadQr.abrevEmpresa}<br></br>{unidadQr.nomRuta}{unidadQr.padronUnidad}{unidadQr.placaUnidad}
                        </label>
                    </div>
                </div>
            </div>
        )
    })

    const propsQr = {
        qrUrl: qrUrl,
        unidadQr: unidadQr
    }

    const propsQrYape = {
        qrUrl : detalleYape.url,
        unidadQr: unidadQr
    }

        return (
            <>
                <ContenedorParametros titulo='Enlace Unidades'>


                    <i className='fa fa-bus'/>
                    
                    <NuevoSelectAutocomplete options={empresasConvertidas} valorInput={recibirValor} valorPorDefecto='1'></NuevoSelectAutocomplete>

                    <i className='fa fa-road'/>
                    <select //select ruta 
                        className={`${classNameInput} containerScroll`} 
                        value={rutaSeleccionada} 
                        onChange={(e) => setRutaSeleccionada(e.target.value)}>
                        <option value={0}>-- Seleccione --</option>
                        {
                            rutas.map((ruta)=>{
                                return <option key={ruta.codRuta} value={ruta.codRuta}>{ruta.nomRuta}</option>
                            })
                        }
                    </select>


                    <BotonProcesar onClick={()=>listarUnidadesQr(empresaSeleccionada, rutaSeleccionada)} />
                    <SearchTable tablaId={idTablaUnidades}></SearchTable>
                </ContenedorParametros>

                   {loading && <Loading/>}


                <div className='hidden'>
                    <div ref={printRef} style={{ display: 'flex', justifyContent: 'center', padding: '1px' }}>
                        
                        <div style={{ backgroundColor: 'white',width: '450px',border: '2px solid black',padding: '15px',
                                display: 'flex',flexDirection: 'column',alignItems: 'center',
                                gap: '0px', position:'absolute',             // Espacio entre QR y texto
                            }}
                        >                        
                            {/* QR: tamaño fijo */}
                            <div style={{ width: '350px', height: '350px', flexShrink: 0 }}>
                                <img 
                                    src={qrUrl} 
                                    style={{ width: '100%', height: '100%', objectFit: 'contain' }} 
                                    alt="QR"
                                />
                            </div>

                            {/* Texto: se ajusta al ancho, rompe líneas */}
                            <label style={{ 
                                color: 'gray',
                                fontFamily: 'Arial, sans-serif',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                wordWrap: 'break-word',
                                overflowWrap: 'break-word',
                                width: '100%',
                                padding: '',
                                lineHeight: '1.3',
                                position:'absolute',
                                bottom: '20px'
                            }}>
                                {unidadQr.abrevEmpresa} {unidadQr.nomRuta}{unidadQr.padronUnidad}{unidadQr.placaUnidad}
                            </label>
                        </div>
                    </div>
                </div>
                <div className='hidden'>
                    <QrImpresion ref={reactToPrintRef} {...propsQr} />
                </div>
                <div className='hidden'>
                    <QrImpresion ref={reactToPrintYapeRef} {...propsQrYape} />
                </div>


                {/* Fin Modulo de Impresión */}


                <div className=" containerScroll mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla ">

                    <table id={idTablaUnidades} className="table">
                        <thead>
                            <tr className=''>
                                <th className="text-center w-[40px]" rowSpan={2}>N</th>
                                {/* <th className="w-[40px]">COD</th> */}
                                <th className='text-center w-[120px]' rowSpan={2}>UNIDAD</th>
                                <th className='text-center w-[40px]' rowSpan={2}>GPS</th>
                                <th className='text-center w-[40px]' rowSpan={2}>MPOS</th>
                                <th className='text-center w-[200px]' rowSpan={2}>FECHA ENLACE</th>
                                <th className='text-center w-[40%]' rowSpan={2}>USUARIO ENLACE</th>
                                <th className="text-center " colSpan={2}>BIIX</th>
                                <th className="text-center " colSpan={2}>ATU</th>
                                <th className="text-center " colSpan={2}>YAPE</th>
                            </tr>
                            <tr>
                                <th className='max-w-[100px] min-w-[100px] w-[100px]'>ESTADO</th>
                                <th className='max-w-[100px] min-w-[100px] w-[100px]'>QR</th>
                                <th className='max-w-[100px] min-w-[100px] w-[100px]'>ESTADO</th>
                                <th className='max-w-[100px] min-w-[100px] w-[100px]'>QR</th>
                                <th className='max-w-[100px] min-w-[100px] w-[100px]'>ESTADO</th>
                                <th className='max-w-[100px] min-w-[100px] w-[100px]'>QR</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                unidadesQr.length > 0 ?
                                    unidadesQr.map((unidad, i) =>{
                                        return (
                                            <tr key={unidad.codUnidad}>
                                                <td>{++i}</td>
                                                {/* <td className="text-center">{unidad.codUnidad}</td> */}
                                                <td className="text-center">{unidad.unidad}</td>
                                                <td className="text-center">{unidad.tieneGPS? <i className='fa fa-check text-blue-300 '/> : ' '}</td>
                                                <td className="text-center" >{unidad.tieneValidador? <i className='fa fa-check text-blue-300 '/> : ' '}</td>
                                                <td className="text-center" >{unidad.fechaHoraCreacionQrBeeX}</td>
                                                <td className="text-center max-w-[140px]" >{unidad.uidCreacionBeex}</td>

                                                {/* Activar / Inactivar Qr Beex */}
                                                <td 
                                                    className="text-center"  
                                                    onClick={(e)=>{openModalConfirmacion();setUnidadQrSeleccionada({unidad,qrTipo:1 })}}
                                                >
                                                    <span className={formatState(unidad.activoQrBeex ? 4 : 7)}>
                                                        {unidad.activoQrBeex ? 'Activo' : 'Inactivo'}
                                                    </span>
                                                </td>
                                                {/* //  Generar QrBeex */} 
                                                <td className='text-center text-[100px]'>
                                                    <>
                                                        <button 
                                                            data-tip 
                                                            data-for={'id-tooltip-' + unidad.codUnidad} 
                                                            onClick={unidad.codUnidadQrBeex? ()=>{obtenerUnidadQr(unidad,1);setUnidadQrSeleccionada({unidad,qrTipo:1 })} : ()=> { generarQr(unidad, 1)}} 
                                                            className={` ${unidad.codUnidadQrBeex? ' bg-blue-500 hover:bg-blue-700 ' : ' hover:bg-blue-800 '}  text-[18px] px-[4px] py-0 rounded`}
                                                        >
                                                            <i className="fas fa-qrcode"></i>
                                                        </button>
                                                        
                                                        <Tooltip id={'id-tooltip-' + unidad.codUnidad}>
                                                            {`${unidad.codUnidadQrBeex? 'Ver QR' : 'Generar QR'}`}
                                                        </Tooltip>
                                                    </>
                                                </td>
                                                {/* Activar / Inactivar Qr Atu */}
                                                <td 
                                                    className="text-center w-[40px]"
                                                    onClick={(e)=>{openModalConfirmacion();setUnidadQrSeleccionada({unidad,qrTipo:2 })}}
                                                >
                                                    <span className={formatState(unidad.activoQrATU ? 4 : 7)}>
                                                        {unidad.activoQrATU ? 'Activo' : 'Inactivo'}
                                                    </span>
                                                </td>
                                                {/* Generar QrAtu */}
                                                <td className='text-center w-[40px]'>
                                                    <>
                                                        <button 
                                                            data-tip 
                                                            data-for={'id-tooltipATU-' + unidad.codUnidad} 
                                                            onClick={unidad.codUnidadQrATU? ()=>{obtenerUnidadQr(unidad,2);setUnidadQrSeleccionada({unidad,qrTipo:2 })} : ()=> generarQr(unidad, 2)} 
                                                            className={` ${unidad.codUnidadQrATU? ' bg-blue-500 hover:bg-blue-700 ' : ' hover:bg-blue-800 '}  text-[18px] px-[4px] py-0 rounded`}
                                                        >
                                                            <i className="fas fa-qrcode"></i>
                                                        </button>
                                                        
                                                        <Tooltip id={'id-tooltipATU-' + unidad.codUnidad}>
                                                            {`${unidad.codUnidadQrATU? 'Ver QR' : 'Generar QR'}`}
                                                        </Tooltip>
                                                    </>
                                                </td>

                                                {/* Activar / Inactivar Qr Yape */}
                                                <td 
                                                    className="text-center w-[40px]"
                                                    // onClick={(e)=>{openModalConfirmacion();setUnidadQrSeleccionada({unidad,qrTipo:2 })}}
                                                >
                                                    <span className={formatState(unidad.activoQrYape ? 4 : 7)}>
                                                        {unidad.activoQrYape ? 'Activo' : 'Inactivo'}
                                                    </span>
                                                </td>
                                                {/* Subir QrYape */}
                                                <td className='text-center w-[40px]'>
                                                    <button 
                                                        data-tip 
                                                        data-for={'id-tooltipYape-' + unidad.codUnidad} 
                                                        onClick={
                                                            ()=> {
                                                                setUnidadQrSeleccionada({ unidad, qrTipo: 3 })
                                                                setImagenQrYape(null)
                                                                setSrcYape(sinImagen)
                                                                setEsSubirQrYape(unidad.codQrYape == 0 ?  true : false) 
                                                                listarDetalleQrYape(unidad.codEmpresa, unidad.codQrYape, unidad.codUnidad)
                                                                openModalYape()
                                                            }
                                                        } 
                                                        className={` ${unidad.codQrYape !== 0 ? ' bg-indigo-600 hover:bg-indigo-700 ' : ' hover:bg-indigo-800 '}  text-[18px] px-[4px] py-0 rounded`}
                                                    >
                                                        <i className="fas fa-qrcode"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        )
                                    })
                                :<tr><td colSpan="12" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                            }
                        </tbody>
                    </table>
                </div>
                
                <Modal 
                    isOpen={isOpenModalUnidadQr} 
                    closeModal={closeModalUnidadQr} 
                    title= {unidadQrSeleccionada?.qrTipo == 1? 'Detalles de Qr Biix' : 'Detalles de Qr ATU'}
                    validButton = {{confirm: true, denied: true}}
                    textButtons = {{confirm: 'Imprimir', denied: 'Cerrar'}}
                    action={()=>printDiv2()}

                    // action={()=>openModalImpresion()}

                >
                
                    <div className="w-full h-full grid grid-cols-2 gap-1 overflow-hidden">
                        <fieldset className='rounded p-4 border border-gray-500 w-full h-full overflow-y-auto'>
                            <legend className='mx-2 flex gap-2 items-center text-xl'>
                                <img 
                                    className="" 
                                    src={unidadQrSeleccionada?.qrTipo==1? icon_beexqr : icon_atuqr}
                                    alt='qr'
                                />
                                <span>Detalles del QR</span>
                            </legend>
                            <div className='grid gap-y-4 grid-cols-[minmax(0,1fr)_minmax(0,9fr)] text-xl'>
                                <i data-tip data-for='EMPRESA' className=' fa fa-bus'/>
                                <span>
                                    {unidadQr.nomEmpresa}
                                    <Tooltip id='EMPRESA'>{`EMPRESA`}</Tooltip>
                                </span>
                                <i data-tip data-for='RUTA' className=' fa fa-road'/>
                                <span>
                                    {unidadQr.nomRuta}
                                    <Tooltip id='RUTA'>{`RUTA`}</Tooltip>
                                </span>
                                <i data-tip data-for='PLACA' className="fa-brands fa-imdb"></i>
                                <span>
                                    {`${unidadQr.padronUnidad} - ${unidadQr.placaUnidad}`}
                                    <Tooltip id='PLACA'>{`PADRON - PLACA`}</Tooltip>
                                </span>
                                <i data-tip data-for='FECHA' className='fa fa-calendar'/>
                                <span>
                                    {unidadQr.fechaHoraCreacion}
                                    <Tooltip id='FECHA'>{`FECHA ENLACE`}</Tooltip>
                                </span>
                                <i data-tip data-for='USUARIO' className='mr-2 fa fa-user'/>
                                <span>
                                    {unidadQr.nomPersonaCreacion}
                                    <Tooltip id='USUARIO'>{`USUARIO ENLACE`}</Tooltip>
                                </span>
                            </div>
                        </fieldset>

                        <div className="p-4 rounded border border-gray-500 w-full h-full overflow-hidden relative">
                            <button data-tip data-for='VERFOTO' className='absolute bottom-4 right-4 bg-blue-500 hover:bg-blue-700 text-xl rounded z-50'>
                                <a 
                                    className="m-1 fa fa-search-plus" 
                                    target="_blank" 
                                    href={qrUrl}
                                > 
                                
                                </a>
                            </button>

                            <Tooltip id='VERFOTO'>{`Ampliar`}</Tooltip>

                            <div className='flex items-center justify-center w-full h-full min-h-0'>
                                <img 
                                    src={qrUrl}  
                                    className="max-w-full max-h-full object-fill rounded" 
                                    alt="sin imagen"
                                />
                            </div>
                        </div>
                    </div>

                </Modal>

                <Modal //Modal confirmación
                    isOpen={isOpenModalConfirmacion} 
                    closeModal={closeModalConfirmacion} 
                    action={()=>{activarInactivarQr(unidadQrSeleccionada); listarUnidadesQr(empresaSeleccionada, rutaSeleccionada);closeModalConfirmacion()}}
                    title= {unidadQrSeleccionada?.qrTipo == 1? unidadQrSeleccionada?.unidad.activoQrBeex? `Inactivar QR Biix [${unidadQrSeleccionada?.unidad?.unidad}]` : `Activar Qr Biix [${unidadQrSeleccionada?.unidad?.unidad}]` : unidadQrSeleccionada?.unidad?.activoQrATU? `Inactivar QR ATU [${unidadQrSeleccionada?.unidad?.unidad}]` : `Activar QR ATU [${unidadQrSeleccionada?.unidad?.unidad}]`}
                    spinner={spinner}
                    textButtons={{ confirm: 'Si', denied: 'No' }}
                >
                    <div className="text-center flex gap-8 items-center flex-wrap justify-center">      
                        <div className="w-[400px] px-4">
                            <label className="text-center">
                                {unidadQrSeleccionada?.qrTipo == 1? unidadQrSeleccionada?.unidad.activoQrBeex? '¿Esta seguro que desea Inactivar QR Biix?' : '¿Esta seguro Activar Qr Biix?' : unidadQrSeleccionada?.unidad.activoQrATU? '¿Esta seguro que desea Inactivar QR ATU?' : '¿Esta seguro que desea Activar QR ATU?'}
                            </label>
                        </div>
                    </div>
                </Modal>

                {/* Modal para subir o ver detalle del qr yape */}
                <Modal
                    isOpen={isOpenModalYape}
                    closeModal={closeModalYape}
                    title={ `[${unidadQr.padronUnidad}] ` + (esSubirQrYape ? `Subir ` : 'Detalle ') + 'imagen Qr Yape'}
                    validButton={{ confirm: true, denied: true }}
                    textButtons={{ confirm: (esSubirQrYape ? 'Guardar' : 'Imprimir'), denied: 'Cerrar' }}
                    action={()=> { esSubirQrYape ? registrarImagen() : imprimirImagenYape()}}
                >
                    <div className='w-[700px] grid grid-cols-[minmax(0,5fr)_minmax(0,5fr)] items-center gap-x-3'>
                        <fieldset className='border rounded h-full w-full border-zinc-500 '> {/* h-min */}
                            <legend className='mx-2 text-lg '>Detalle del Yape</legend>
                            <div className='p-3 text-lg grid grid-cols-[minmax(0,1fr)_minmax(0,9fr)] items-center  gap-3 col-x-2'>
                                <i className='fa fa-bus' title='Empresa'></i>
                                <label>{unidadQr?.nomEmpresa}</label>
                                <i className='fa fa-road' title='Ruta'></i>
                                <label>{unidadQr?.nomRuta}</label>
                                <i className='fa fa-brands fa-imdb' title='Placa'></i>
                                <label>{unidadQr?.placaUnidad}</label>
                                <i className='fa fa-solid fa-mobile-screen-button' title='Telefono'></i>
                                <input
                                    className={classNameInput +  `caret-white care`}
                                    value={detalleYape.telefono}
                                    placeholder='Escriba aquí su número de yape...'
                                    onKeyPress={(e) => soloCelular(e, e.target)}
                                    onChange={(e) => editarValorDetalleYape('telefono', e.target.value)}
                                    disabled={esSubirQrYape ? false : true}
                                    readOnly={esSubirQrYape ? false : true}
                                />
                                {
                                    esSubirQrYape? 
                                    <>
                                    </>
                                    :
                                    <>
                                    <i className='fa fa-file'></i>
                                    <label className='break-words text-xs  bg-zinc-900 rounded p-1'>{detalleYape.datosYape}</label>
                                    </>
                                }
                            </div>
                        </fieldset>
                        <div className='grid gap-2 py-3'>
                            <div className='border border-zinc-500 relative border-dashed p-[10px] rounded w-full'>
                                <img
                                    ref={imagenYapeRef}
                                    src={esSubirQrYape ? srcYape : detalleYape.url}
                                    className='w-full h-[340px] '//cursor-zoom-in
                                    alt='imgYape'
                                ></img>
                                <button data-tip data-for='VERFOTO' className='absolute right-2 bottom-3 bg-blue-500 hover:bg-blue-700 text-xl rounded z-50'>
                                    <a 
                                        className="m-1 fa fa-search-plus" 
                                        target="_blank" 
                                        href={esSubirQrYape ? srcYape : detalleYape.url}
                                    > 
                                    
                                    </a>
                                </button>
                            </div>
                            {
                                esSubirQrYape ? 
                                    <div className='w-full flex justify-center'>
                                        <label
                                            htmlFor='fileUpload'
                                            className='p-2 w-[35%] rounded-md bg-indigo-600 cursor-pointer font-medium hover:bg-indigo-800'
                                        >Subir Imagen</label>
                                        <input
                                            id='fileUpload'
                                            onChange={(e) => {
                                                if(e.target.files.length > 0){
                                                    if(e.target.files[0].type !== 'image/webp'){
                                                        setImagenQrYape(e.target.files[0])
                                                        setSrcYape(URL.createObjectURL(e.target.files[0]))
                                                    }
                                                    else{
                                                        notify('Seleccione una imagen con extensión .png .jpg o .jpge', 'error')
                                                        setImagenQrYape(null);
                                                        setSrcYape(sinImagen)
                                                    }
                                                }
                                            }}
                                            type='file'
                                            className='hidden'
                                            accept='.png,.jpg,.jpeg'
                                        />
                                    </div>
                                :
                                    <></>
                            }
                        </div>
                    </div>
                </Modal>
            </>
    )
}